enum Gender {
    MAN = 1,
    WOMAN = 2   
  }

  export default Gender;